export default __webpack_public_path__ + "static/media/kitchen3-afterG-480w.d66be9f3.avif";